import React from 'react'

import { Link } from 'react-router-dom'

import isEmptyObject from 'app/shared_components/check_empty_object'
import * as validations from 'app/shared_components/validations'

class ProfileNewPasswordForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      errors: {},
      showold: false,
      shownew: false,
      disabled: true,
      clicked: false,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ clicked: false })
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    nextState.disabled = !(
      nextState.currentPassword &&
      nextState.newPassword &&
      nextState.newPasswordConfirm &&
      isEmptyObject(nextState.errors) &&
      !nextState.clicked
    )
  }

  setValidationErrors(field, error) {
    let errors = this.state.errors
    if (error.length == 0) {
      // No validation errors
      delete errors[field]
      this.setState({ errors })
      document.getElementById(field).className = ''
      return true
    } else {
      // Validation errors
      errors[field] = error
      this.setState({ errors })
      document.getElementById(field).className = 'error'
      return false
    }
  }

  submit = () => {
    return (event) => {
      this.setState({ clicked: true })
      let { changePassword } = this.props
      changePassword(this.state)
    }
  }

  toggleShow(field) {
    return () => {
      field = 'show' + field
      let value = this.state[field]
      this.setState({ [field]: !value })
    }
  }

  update(field) {
    return (event) => this.setState({ [field]: event.target.value })
  }

  updatePassword(field) {
    return (event) => {
      this.setState({ [field]: event.target.value })
    }
  }

  validate(field) {
    return () => {
      let value = this.state[field]
      switch (field) {
        case 'newPasswordConfirm':
          if (this.state.newPassword === this.state.newPasswordConfirm) {
            return this.setValidationErrors(field, [])
          }
          return this.setValidationErrors(field, 'Passwords do not match')
        default:
          return this.setValidationErrors(
            field,
            validations.validateNewPassword(value),
          )
      }
    }
  }

  render() {
    let {
      currentPassword,
      newPassword,
      errors,
      newPasswordConfirm,
      disabled,
      clicked,
    } = this.state
    let { error, success } = this.props
    return (
      <div className="two-col-box-flex-row sm64">
        <div className="col-first">
          <h3 className="mb15">New Password</h3>

          <p className="mb30">Please enter a new password for Snug.</p>

          <div className="input-box">
            <input
              type={this.state.shownew ? 'text' : 'password'}
              required
              id="newPassword"
              value={newPassword}
              onChange={this.update('newPassword')}
              onBlur={this.validate('newPassword')}
            />
            <label>New Password</label>
            <span className="show-password" onClick={this.toggleShow('new')}>
              Show
            </span>
          </div>

          <div className="input-box">
            <input
              type={this.state.showcon ? 'text' : 'password'}
              required
              id="newPasswordConfirm"
              value={newPasswordConfirm}
              onChange={this.update('newPasswordConfirm')}
              onBlur={this.validate('newPasswordConfirm')}
            />
            <label>Confirm Password</label>
            <span className="show-password" onClick={this.toggleShow('con')}>
              Show
            </span>
          </div>

          <ul className="snug-infos mt40">
            <li>Snug uses bank-level 256-bit security to protect your data.</li>
          </ul>

          <div
            className={
              !isEmptyObject(errors) || error ? 'alert alert-danger' : ''
            }
          >
            {error} {errors.currentPassword} {errors.newPassword}{' '}
            {errors.newPasswordConfirm}
          </div>

          <div className={success ? 'alert alert-success' : 'hidden'}>
            {success}
          </div>

          <button className="mt15" disabled={disabled} onClick={this.submit()}>
            Save
            <i className={clicked ? 'fa fa-spinner fa-pulse' : ''} />
          </button>
        </div>
      </div>
    )
  }
}

export default ProfileNewPasswordForm
